import { network } from 'services/network';

import { QueryParams } from 'api/mutations/testNarrativeText.mutation';

export const testNarrativeText = (params: QueryParams) => {
    return network.post('api/bo/narratives/testNarrativeText', params).then((response) => {
        return response.data;
    });
};
